var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"my-3 mx-3",staticStyle:{"display":"flex","justify-content":"center"}},[_c('b-button',{attrs:{"variant":"outline-primary"},on:{"click":function($event){return _vm.navegar()}}},[_vm._v(" Navegar a Dos ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }